import User from '../user/User'
import Location from '../company/Location'
import { Register } from '../company/Register'
import UUIDBase from '../UUIDBase'
import Item from "@/models/inventory/Item";



export interface InventoryTransactionsPaginated {
    data: Array<InventoryTransaction>,
    total: number
}

export class InventoryTransaction extends UUIDBase {
    static ENDPOINT = '/inventory/inventorytransactions'

    quantity = 0

    user = new User()
    userID?: string

    item = new Item()
    itemID?: string

    location = new Location()
    locationID?: string

    register = new Register()
    registerID?: string

    type = ''

    referenceableID?: string
    referenceableType?: string

    static from(json: Record<string, unknown> | InventoryTransaction) {
        const t = Object.assign(new InventoryTransaction(), json)
        t.user = User.from(t.user)
        t.location = Location.from(t.location)
        t.item = Item.from(t.item)

        return t
    }
}
